import type { BaseController } from '@infra/controllers/base.controller';
import type { MuteToggleUsecase } from '@usecases/mute-toggle.usecase';

export type MuteToggleInput = {
  onMute: boolean;
};

export type MuteToggleOutput = void;

export class MuteToggleController
  implements BaseController<MuteToggleInput, MuteToggleOutput>
{
  constructor(private usecase: MuteToggleUsecase) {}

  async handle(req: MuteToggleInput): Promise<MuteToggleOutput> {
    await this.usecase.run(req.onMute);
  }
}
